import {
    matchType
} from "@/utils/index";
class preload {
    // 已经加载的数量
    loadedCount = 0
    total = 0
    cb = null
    constructor(url, cb) {
        this.total = url.length;
        this.cb = cb;
        this.initEvent(url);
    }
    initEvent(url) {
        url.forEach(u => {
            const fileType = matchType(String(u));
            if (fileType == "image") {
                this.loadImg(u);
            } else {
                this.loaded();
            }
        });
    }
    loadImg(url) {
        var img = new Image();
        img.addEventListener("load", this.loaded.bind(this), false);
        img.addEventListener("error", this.loaded.bind(this), false);
        img.src = url;
    }
    loadAudio(url) {
        var audio = new Audio();
        audio.addEventListener("canplaythrough", this.loaded.bind(this), false);
        audio.addEventListener("error", this.loaded.bind(this), false);
        audio.src = url;
    }
    loaded() {
        this.loadedCount++;
        if (this.loadedCount >= this.total) {
            if (typeof this.cb == "function") {
                this.cb();
            }
        }
    }
}

export default preload;